<template>
  <div class="grid-x grid-padding-x align-center">
    <div class="cell medium-12 large-3 small-order-2 large-order-1">
      <eal-search-filters-component
        :nonce="nonce"
        :apiUrls="apiUrls"
        ref="searchFiltersComponentRef"
        @onSubmit="submit"
        is-on-results-page="true"
        base-page-path="/transfer-options/eal/"
        results-page-path="/transfer-options/eal/search-result/"
      >
      </eal-search-filters-component>
    </div>

    <div class="cell medium-12 large-9 small-order-1 large-order-2 o-search-result">
      Search Result
      <div class="o-search-results">
        <div class="o-search-results__header s-content-block s-content-block--small">
          <div class="o-search-results__title">
            <h3>English as an Additional Language Transfer</h3>
            <div class="o-search-results__button">
              <form id="save-to-pdf-form" target="_blank" method="POST"></form>
              <button
                type="button"
                class="a-button a-button--small a-button--primary-outline"
                @click="downloadPdf"
              >
                Save to PDF
              </button>
              <button type="button" class="a-button a-button--small" @click="newSearch">
                New Search
              </button>
            </div>
          </div>
        </div>

        <div class="s-content-block s-content-block--small">
          <div class="callout secondary shadow-none">
            <div class="grid-x grid-margin-x align-top eal-credit-guide">
              <div class="cell small-12 large-6 eal-credit-guide__code-panel">
                <p class="h5 text-dark">How to read Transfer Credit & Total Hours:</p>

                <div class="flex-container align-top eal-credit-guide__code-row">
                  <div class="bracket-group">
                    <span class="code-text">DOUG</span>
                    <div class="u-bracket"></div>
                    <span class="index">1</span>
                  </div>

                  <div class="bracket-group">
                    <span class="code-text">ELLA</span>
                    <div class="u-bracket"></div>
                    <span class="index">2</span>
                  </div>

                  <div class="bracket-group">
                    <span class="code-text">0010</span>
                    <div class="u-bracket"></div>
                    <span class="index">3</span>
                  </div>

                  <div class="flex-container align-top eal-credit-guide__credit-hours">
                    <span class="code-text">(</span>
                    <div class="bracket-group">
                      <span class="code-text">3</span>
                      <div class="u-bracket"></div>
                      <span class="index">4</span>
                    </div>
                    <span class="code-text">,</span>
                    <div class="bracket-group">
                      <span class="code-text">72</span>
                      <div class="u-bracket"></div>
                      <span class="index">5</span>
                    </div>
                    <span class="code-text">)</span>
                  </div>
                </div>
              </div>

              <div class="cell small-12 large-6 eal-credit-guide__details-panel">
                <ul class="no-bullet legend-list">
                  <li><span class="red-num">1.</span> “DOUG” is the institution code</li>
                  <li><span class="red-num">2.</span> “ELLA” is the subject code</li>
                  <li><span class="red-num">3.</span> “0010” is the course number</li>
                  <li><span class="red-num">4.</span> “3” is the credits/units awarded</li>
                  <li><span class="red-num">5.</span> “72” is the total hours</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="o-search-result__table-total-page">
            <div class="text-center medium-text-left">
              {{ pageFrom }} to {{ pageTo }} of {{ totalAgreements }} matches <br />
            </div>
            <ul class="pagination" v-if="totalPages > 1">
              <li
                :class="['page-item', { disabled: currentPage === 1 }]"
                :disabled="currentPage === 1"
              >
                <button
                  :class="['page-link', { disabled: currentPage === 1 }]"
                  :disabled="currentPage === 1"
                  @click="goToFirstPage"
                >
                  First
                </button>
              </li>
              <paginate
                v-model="currentPage"
                :page-count="totalPages"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
                <template #page="{ page, selected, disabled }">
                  <li :class="{ selected: selected }">
                    <button :disabled="disabled" @click="pageClick(page)">
                      {{ page }}
                    </button>
                  </li>
                </template>
              </paginate>
              <li
                :class="['page-item', { disabled: currentPage === totalPages }]"
                :disabled="currentPage === totalPages"
              >
                <button
                  :class="['page-link', { disabled: currentPage === totalPages }]"
                  :disabled="currentPage === totalPages"
                  @click="goToLastPage"
                >
                  Last
                </button>
              </li>
            </ul>
          </div>
          <div class="o-search-results__table-wrapper">
            <div
              class="o-search-results__table"
              v-if="searchResponse.skills != null && _.get(searchResponse, 'skills.length') > 0"
            >
              <!-- Headers -->
              <div class="o-search-results__table-header adult-basic-education">
                <div class="grid-x">
                  <!-- <div class="cell small-2"><strong>Skills</strong></div> -->
                  <div class="cell small-12 cell-no-padding">
                    <div class="grid-x">
                      <div class="cell small-3"><strong>Program Area-Level-Skill</strong></div>
                      <div class="cell small-9 cell-no-padding">
                        <div class="grid-x">
                          <div class="cell small-4">
                            <strong>Institution</strong>
                          </div>
                          <div class="cell small-5">
                            <strong>Transfer Credit & Total Hours</strong>
                          </div>
                          <div class="cell small-3">
                            <strong>Effective Date</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="o-search-results__table-row adult-basic-education">
                <div class="grid-x" v-for="skill in searchResponse.skills" :key="skill.skillId">
                  <!-- Skill -->
                  <!-- <div class="cell small-2">
                      <div class="flex-container">
                        <span>{{ skill.SkillName }}</span>
                      </div>
                    </div> -->

                  <!-- Level -->
                  <div class="cell small-12 cell-no-padding">
                    <!-- <div class="grid-x"> -->
                    <div class="grid-x" v-for="level in skill.levels" :key="level.levelId">
                      <div class="cell small-12">
                        <div class="flex-container">{{ skill.label }}</div>
                      </div>

                      <div class="cell small-3"></div>

                      <div class="cell small-9 cell-no-padding">
                        <div
                          class="grid-x"
                          v-for="agreement in level.agreements"
                          :key="agreement.id"
                        >
                          <!-- <div class="grid-x"> -->
                          <!-- Institution -->
                          <div class="cell small-4">
                            <div class="flex-container">
                              <div
                                class="o-search-results__logo"
                                :data-tooltip="agreement.sndrInstitutionName"
                              >
                                <!-- <div class="o-search-results__logo" :data-tooltip="agreement.SenderInstitutionName"> -->
                                <img
                                  :src="`${logosUrl}/${agreement.sndrGlobalInstitutionID}_icon.png`"
                                />
                              </div>
                              <span>{{ agreement.sndrInstitutionCode }}</span>
                            </div>
                          </div>

                          <!-- Transfer Credit -->
                          <div class="cell small-5">
                            {{ agreement.detail
                            }}{{ agreement.condition ? `, ${agreement.condition}` : '' }}
                          </div>

                          <!-- Effective Date -->
                          <div class="cell small-3">
                            {{ agreementEffectiveDateDate(agreement) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h6 v-else-if="_.get(searchResponse, 'skills.length') == 0">
              There are no transfer agreements for that search. Please try again.
            </h6>
          </div>
          <div class="o-search-result__table-page">
            <ul class="pagination" v-if="totalPages > 1">
              <li
                :class="['page-item', { disabled: currentPage === 1 }]"
                :disabled="currentPage === 1"
              >
                <button
                  :class="['page-link', { disabled: currentPage === 1 }]"
                  :disabled="currentPage === 1"
                  @click="goToFirstPage"
                >
                  First
                </button>
              </li>
              <paginate
                v-model="currentPage"
                :page-count="totalPages"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
                <template #page="{ page, selected, disabled }">
                  <li :class="{ selected: selected }">
                    <button :disabled="disabled" @click="pageClick(page)">
                      {{ page }}
                    </button>
                  </li>
                </template>
              </paginate>
              <li
                :class="['page-item', { disabled: currentPage === totalPages }]"
                :disabled="currentPage === totalPages"
              >
                <button
                  :class="['page-link', { disabled: currentPage === totalPages }]"
                  :disabled="currentPage === totalPages"
                  @click="goToLastPage"
                >
                  Last
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch } from 'vue'
import axios from 'axios'
import _ from 'lodash'
import EalSearchFiltersComponent from './EalSearchFiltersComponent.vue'
import Paginate from 'vuejs-paginate-next'

const props = defineProps({
  nonce: { type: String, required: true },
  logosUrl: { type: String, required: true },
  apiUrls: { type: Object, required: true },
})

const searchResponse = reactive({
  skills: null,
})

const searchRequestCancelToken = ref(null)
const pdfRequestCancelToken = ref(null)
const pageLength = ref(null)
const pageFrom = ref(null)
const pageTo = ref(null)
const currentPage = ref(1)
const totalPages = ref(0)
const totalAgreements = ref(0)
const currentFilterData = reactive({})

const searchFiltersComponentRef = ref(null)

const goToFirstPage = () => {
  currentPage.value = 1
}

const goToLastPage = () => {
  currentPage.value = totalPages.value
}

watch(currentPage, (newCurrentPage, old) => {
  if (newCurrentPage === old || (newCurrentPage === 1 && old === null)) {
    return
  }

  const data = _.clone(currentFilterData)
  _.set(data, 'pageNumber', newCurrentPage)

  submit(data)
})

const submit = (data) => {
  // if pageNumber is not in data, reset it
  Object.assign(currentFilterData, _.clone(data))
  if (data && !Object.prototype.hasOwnProperty.call(data, 'pageNumber')) {
    delete currentFilterData.pageNumber
  }

  searchRequestHandler('/wp-json/bctg-search/eal/agreements', currentFilterData, data)
}

const searchRequestHandler = (path, params) => {
  if (searchRequestCancelToken.value) {
    searchRequestCancelToken.value.cancel()
  }

  searchRequestCancelToken.value = axios.CancelToken.source()
  searchResponse.skills = null

  document.body.classList.add('js-is-searching')
  $('html, body').animate({ scrollTop: $('.js-header').offset().top + 200 }, '400')

  axios
    .post(`${path}?_wpnonce=${props.nonce}`, params, {
      cancelToken: searchRequestCancelToken.value.token,
    })
    .then((response) => searchResponseHandler(response))
}

const searchResponseHandler = (response) => {
  Object.assign(searchResponse, response.data)
  document.body.classList.remove('js-is-searching')

  const attributes = {
    currentPage,
    totalPages,
    totalAgreements,
    pageLength,
    pageFrom,
    pageTo,
  }

  Object.keys(attributes).forEach((key) => {
    const value = _.get(searchResponse, key)
    if (value !== attributes[key].value) {
      attributes[key].value = value
    }
  })
}

const downloadPdf = (event) => {
  event.preventDefault()

  const saveToPdfFormElement = document.getElementById('save-to-pdf-form')
  saveToPdfFormElement.action = `/wp-json/bctg-search/eal/agreements/pdf?_wpnonce=${props.nonce}`
  saveToPdfFormElement.innerHTML = ''

  _.forEach(currentFilterData, (paramValue, paramName) => {
    const newInput = document.createElement('input')
    newInput.type = 'hidden'
    newInput.id = paramName
    newInput.name = paramName
    newInput.value = paramValue
    saveToPdfFormElement.append(newInput)
  })

  saveToPdfFormElement.submit()
}

const newSearch = () => {
  searchFiltersComponentRef.value.newSearch()
}

const agreementEffectiveDateDate = (agreement) => {
  const dateFormat = { year: '2-digit', month: 'short' }

  const formatDate = (dateString) => {
    const date = new Date(dateString.slice(0, 4), dateString.slice(4, 6) - 1, 1)
    const formattedDate = new Intl.DateTimeFormat('en-US', dateFormat).format(date)
    return formattedDate.replace(' ', '/')
  }

  let startDate = _.get(agreement, 'startDate')
  if (startDate) {
    startDate = formatDate(startDate)
  }

  let endDate = _.get(agreement, 'endDate')
  if (endDate) {
    endDate = formatDate(endDate)
  }

  if (startDate && endDate) {
    return `${startDate} to ${endDate}`
  }

  if (startDate) {
    return `${startDate} ongoing`
  }

  return ''
}
</script>

<style>
.code-text {
  font-size: clamp(1.2rem, 0.95rem + 1.8vw, 2.25rem);
  line-height: 1.05;
  font-family: Arial, sans-serif;
  color: #0a0a0a;
}

.eal-credit-guide__code-panel,
.eal-credit-guide__details-panel {
  min-width: 0;
}

.eal-credit-guide__code-row,
.eal-credit-guide__credit-hours {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.eal-credit-guide__code-row {
  flex-wrap: nowrap;
}

.eal-credit-guide__credit-hours {
  flex-wrap: nowrap;
}

.bracket-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0.25rem;
  flex: 0 1 auto;
}

.u-bracket {
  width: 100%;
  height: 8px;
  border: 1px solid #767676;
  border-top: none;
  margin-top: 4px;
}

.index {
  color: #cc4b37;
  font-size: 1.25rem;
  font-weight: 500;
  margin-top: 2px;
}

.legend-list li {
  font-size: 1.15rem;
  margin-bottom: 0.5rem;
  line-height: 1.4;
}

.red-num {
  color: #cc4b37;
  font-weight: bold;
  margin-right: 8px;
}

.flex-container.align-top {
  display: flex;
  align-items: flex-start;
}

.callout.secondary {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
}

@media (max-width: 39.9375em) {
  .eal-credit-guide__code-row,
  .eal-credit-guide__credit-hours {
    gap: 0.35rem;
  }

  .legend-list li {
    font-size: 1rem;
  }

  .index {
    font-size: 1rem;
  }
}

@media print, screen and (min-width: 40em) and (max-width: 73.9375em) {
  .code-text {
    font-size: clamp(1.4rem, 1.05rem + 1.2vw, 1.85rem);
  }

  .eal-credit-guide__code-panel,
  .eal-credit-guide__details-panel {
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;
  }
}

@media print, screen and (min-width: 65.625em) {
  .grid-x > .large-3 {
    width: 29%;
  }
}

@media print, screen and (min-width: 65.625em) {
  .grid-x > .large-9 {
    width: 71%;
  }
}
</style>
